module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "box"
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('ul', {
    ref: "con1",
    class: {
      anim: _vm.animate == true
    },
    attrs: {
      "id": "con1"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": require("../../../static/laba.gif"),
        "height": "25",
        "width": "25"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(item))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71823a99","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Announcement.vue
// module id = 1882
// module chunks = 8